var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeClosedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.313 6.2C13.579 6.07 12.806 6 12 6c-6.034 0-9.994 4-11 6 .476.946 1.613 2.34 3.318 3.546L14.313 6.2zM9.688 17.799c.732.13 1.504.201 2.313.201 6.034 0 9.994-4 11-6-.4-.953-1.546-2.36-3.29-3.573L9.687 17.8z",
    fill: "#9A9CAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3.5l2-.5-.5 2L5 20.5 3 21l.5-2L19 3.5z",
    fill: "#9A9CAC"
  })));
}

export default SvgEyeClosedIcon;